<div
  class="card-container"
  [ngClass]="{ unAvaliable: card.count === 0 }"
  *ngFor="let card of cards"
  (click)="takeCard(card)"
>
  <app-card
    class="card"
    [disabled]="card.count === 0"
    [cardSize]="{ width: '8.7', height: '12', iconSize: '1.7' }"
    [cardBackground]="card.apiCard.appearance?.backgroundImage"
    [leftIcon]="card.apiCard.appearance?.levelImage"
    [centerElement]="card.apiCard.appearance?.mainImage"
    [rightIcon]="card.apiCard.appearance?.effectImage"
    [cardTitle]="card.apiCard.appearance?.displayName"
    [fontSize]="card.apiCard.type === 'EXPERIENCE' ? 0.8 : 1.2"
    [cardHolder]="card"
    [quanity]="card.count"
  ></app-card>
</div>
